/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {OpenAPI as IamClient} from '../generated/iam-client';
import {IAM_BASE_URL} from '../applicationContext';

export default class ApiClientsConfigurer {

	static configureApiClients(): void {
		IamClient.BASE = IAM_BASE_URL;
	}
}
